import React from 'react';
// Styles
import './VideoPlayer.css';
import ReactPlayer from 'react-player/lazy';

const VideoPlayer = (props) => {
  return (
    <>
      <ReactPlayer {...props}></ReactPlayer>
    </>
  );
};

export default VideoPlayer;

// import React from 'react';
// // Styles
// import './VideoPlayer.css';
// import ReactPlayer from 'react-player/lazy';

// class VideoPlayer extends React.Component {
//   constructor(props) {
//     super(props);

//     this.videoRef = React.createRef();

//     let { playing, onReady, onEnded, volume, ...rest } = this.props;

//     this.rest = rest;
//     this.playing = playing;
//     this.onReady = onReady;
//     this.onEnded = onEnded;
//     this.volume = volume;

//     // width='100%'
//     // playsInline
//     // height='100%'
//     // playing={isReady}
//     // volume={0.8}
//     // onReady={this.handleOnReadyPlayer}
//     // onEnded={this.handleOnEndVideo}
//     // src={process.env.REACT_APP_PRESENTATION_VIDEO_URL}
//   }

//   setVideoRef = (element) => {
//     this.videoRef = element;
//   };

//   play = () => {
//     this.videoRef.play();
//   };

//   componentDidMount = () => {};

//   componentDidUpdate = (prevProps) => {
//     if (prevProps.playing !== this.playing) {
//       this.play();
//     }
//   };

//   render() {
//     return (
//       <div className='player'>
//         <video {...this.rest} ref={this.setVideoRef}></video>
//       </div>
//     );
//   }
// }

// export default VideoPlayer;
